<template>
  <div class="sucai-selector-wrap">
    <div class="sucai-search-bar">
      <span class="sucai-label">素材名称</span>
      <el-input v-model="query.materialName" placeholder="请输入素材名称" clearable style="width: 240px" />
      <span class="sucai-label">时长(秒)</span>
      <el-input v-model="query.minDuration" placeholder="最小" size="small" clearable class="sucai-duration-input" />
      <span class="sucai-range-sep">-</span>
      <el-input v-model="query.maxDuration" placeholder="最大" size="small" clearable class="sucai-duration-input" />
      <el-button type="warning" size="small" @click="searchClick">查询</el-button>
      <el-button size="small" @click="selectAll">{{ isAllSelected ? '取消全选' : '全选' }}</el-button>
      <span v-if="selectedIds.length > 0" class="sucai-selected-count">已选 {{ selectedIds.length }} 个</span>
    </div>

    <el-empty v-if="filteredList.length === 0" description="暂无素材" />
    <div v-else class="sucai-grid">
      <div v-for="item in filteredList" :key="item.material_id" class="sucai-grid-item"
        :class="{ active: selectedIds.includes(item.material_id) }" @click="toggleSelect(item)">
        <div class="sucai-cover">
          <img :src="item.poster_url" />
          <div v-show="selectedIds.includes(item.material_id)" class="sucai-mask"></div>
          <span v-show="selectedIds.includes(item.material_id)" class="sucai-check">✓</span>
        </div>
        <div class="sucai-meta">
          <div class="sucai-name" :title="item.material_name || item.file_name">
            {{ item.material_name || item.file_name }}
          </div>
          <div v-if="item.duration !== undefined && item.duration !== null && item.duration !== ''"
            class="sucai-duration">
            时长 {{ Number(item.duration).toFixed(0) }}s
          </div>
          <div v-if="item.create_time" class="sucai-create-time"> {{ item.create_time }}</div>
        </div>
      </div>
    </div>

    <div class="pagination sucai-pagination">
      <pagination :total="total" :pagesize="query.pageSize" :currentPage="query.page"
        @handleSizeChange="handleSizeChange" @handleCurrentChange="handleCurrentChange"></pagination>
    </div>

    <div class="sucai-footer">
      <el-button @click="$emit('cancel')">取消</el-button>
      <el-button type="primary" @click="confirm">确定</el-button>
    </div>
  </div>
</template>

<script>
import { reactive, toRefs, computed } from 'vue'
import { ElMessage } from 'element-plus'
import pagination from '@/components/pagination.vue'
import { sucaiEbpVideoList, sucaiEbpVideoListByAdvertiser } from '@/request/new/ylyBatch'

export default {
  name: 'ylySucaiSelector',
  components: { pagination },
  props: {
    // 账户维度 id，对应原来 sucaiQuery.accountId（取 config.accountIds[0] 传进来）
    advertiserId: { type: [String, Number], default: '' },
    // 组织维度 id（保留，原 sucaiSearchFun 用；默认不用）
    orgAccountId: { type: [String, Number], default: '' },
    // 0 组织 1 账户，原 sucaiQuery.type，默认 1，和现状一致
    queryType: { type: Number, default: 1 },
    // 默认素材名称，原来取 scope.row.productName 传进来
    defaultMaterialName: { type: String, default: '' },
    // 已选回显，原来是 scope.row.sucai（归一化后的数组，带 materialId）
    checkedList: { type: Array, default: () => [] },
    defaultPageSize: { type: Number, default: 100 },
  },
  emits: ['confirm', 'cancel'],
  setup(props, { emit }) {
    const state = reactive({
      query: {
        // 打开即用 defaultMaterialName 初始化（原来 openSucaiSelectFun 里 materialName = productName）
        materialName: props.defaultMaterialName || '',
        materialRange: 'all',
        page: 1,
        pageSize: props.defaultPageSize,
        type: props.queryType,
        // 打开即用 advertiserId 初始化（原来 openSucaiSelectFun 里 accountId = accountIds[0]）
        accountId: props.advertiserId || '',
        minDuration: '',
        maxDuration: '',
      },
      list: [],
      total: 0,
      // 打开即用 checkedList 回显（原来 openSucaiSelectFun 里从 scope.row.sucai 重建）
      selectedIds: (props.checkedList || []).map((item) => item.materialId),
      selectedMap: {},
    })
      ; (props.checkedList || []).forEach((item) => {
        state.selectedMap[item.materialId] = { ...item }
      })

    // 接口字段归一化：和原来 normalizeSucaiItem 一字不差
    // 组织维度 material_name / 账户维度 file_name -> materialName
    // image_mode 没有时用 format + 宽高推导横竖版
    const normalizeItem = (item) => {
      let imageMode = item.image_mode || null
      if (!imageMode && item.format === 'MP4') {
        imageMode = item.width > item.height ? 'CREATIVE_IMAGE_MODE_VIDEO' : 'CREATIVE_IMAGE_MODE_VIDEO_VERTICAL'
      }
      if (!imageMode && item.width && item.height) {
        imageMode = item.width > item.height ? 'CREATIVE_IMAGE_MODE_VIDEO' : 'CREATIVE_IMAGE_MODE_VIDEO_VERTICAL'
      }
      return {
        materialId: item.material_id,
        materialName: item.material_name || item.file_name,
        posterUrl: item.poster_url,
        url: item.url,
        videoId: item.video_id,
        materialType: item.format || 'MP4',
        duration: item.duration,
        imageMode,
      }
    }

    const searchByOrg = () => {
      if (!props.orgAccountId && !state.query.accountId) {
        ElMessage.error('请先选择组织')
        return
      }
      const datas = {
        accountId: props.orgAccountId || state.query.accountId,
        materialName: state.query.materialName || undefined,
        materialRange: state.query.materialRange,
        page: state.query.page,
        pageSize: state.query.pageSize,
      }
      sucaiEbpVideoList(datas).then((res) => {
        if (res.code == 200) {
          state.list = res.data.videos || []
          state.total = (res.data.pageInfo && res.data.pageInfo.totalNumber) || 0
        } else {
          ElMessage.error(res.msg)
        }
      })
    }

    const searchByAdvertiser = () => {
      if (!state.query.accountId) {
        ElMessage.error('请先填写账户id')
        return
      }
      const datas = {
        advertiserId: state.query.accountId,
        materialName: state.query.materialName || undefined,
        page: state.query.page,
        pageSize: state.query.pageSize,
      }
      sucaiEbpVideoListByAdvertiser(datas).then((res) => {
        if (res.code == 200) {
          state.list = res.data.videos || []
          state.total = (res.data.pageInfo && res.data.pageInfo.totalNumber) || 0
        } else {
          ElMessage.error(res.msg)
        }
      })
    }

    const searchClick = () => {
      if (Number(state.query.type) === 1) {
        searchByAdvertiser()
      } else {
        searchByOrg()
      }
    }

    const handleCurrentChange = (e) => {
      state.query.page = e
      searchClick()
    }

    const handleSizeChange = (e) => {
      state.query.pageSize = e
      state.query.page = 1
      searchClick()
    }

    // 时长前端过滤：不走接口，只按当前页 list 的 duration 过滤，和原来 filteredSucaiList 一致
    const filteredList = computed(() => {
      const min =
        state.query.minDuration === '' || state.query.minDuration === null || state.query.minDuration === undefined
          ? null
          : Number(state.query.minDuration)
      const max =
        state.query.maxDuration === '' || state.query.maxDuration === null || state.query.maxDuration === undefined
          ? null
          : Number(state.query.maxDuration)
      if ((min === null || Number.isNaN(min)) && (max === null || Number.isNaN(max))) {
        return state.list
      }
      return state.list.filter((item) => {
        const d = Number(item.duration)
        if (Number.isNaN(d)) return false
        if (min !== null && !Number.isNaN(min) && d < min) return false
        if (max !== null && !Number.isNaN(max) && d > max) return false
        return true
      })
    })

    const isAllSelected = computed(() => {
      if (filteredList.value.length === 0) return false
      return filteredList.value.every((item) => state.selectedIds.includes(item.material_id))
    })

    const selectAll = () => {
      if (isAllSelected.value) {
        const pageIds = filteredList.value.map((item) => item.material_id)
        state.selectedIds = state.selectedIds.filter((id) => !pageIds.includes(id))
        pageIds.forEach((id) => {
          delete state.selectedMap[id]
        })
      } else {
        filteredList.value.forEach((item) => {
          if (!state.selectedIds.includes(item.material_id)) {
            state.selectedIds.push(item.material_id)
          }
          state.selectedMap[item.material_id] = normalizeItem(item)
        })
      }
    }

    const toggleSelect = (item) => {
      const index = state.selectedIds.indexOf(item.material_id)
      if (index > -1) {
        state.selectedIds.splice(index, 1)
        delete state.selectedMap[item.material_id]
      } else {
        state.selectedIds.push(item.material_id)
        state.selectedMap[item.material_id] = normalizeItem(item)
      }
    }

    const confirm = () => {
      if (state.selectedIds.length === 0) {
        ElMessage.warning('请先勾选素材')
        return
      }
      // 先把当前页最新数据刷进跨页缓存，再按勾选顺序组装（和原来 confirmSucaiSelectFun 一致）
      state.list.forEach((item) => {
        if (state.selectedIds.includes(item.material_id)) {
          state.selectedMap[item.material_id] = normalizeItem(item)
        }
      })
      const result = state.selectedIds.map((id) => state.selectedMap[id]).filter(Boolean)
      emit('confirm', JSON.parse(JSON.stringify(result)))
    }

    // 挂载即按 props 初始化并发起首屏查询（父页面 v-if 保证每次打开都是全新实例，无需手动 reset）
    searchClick()

    return {
      ...toRefs(state),
      query: state.query,
      filteredList,
      isAllSelected,
      searchClick,
      handleCurrentChange,
      handleSizeChange,
      selectAll,
      toggleSelect,
      confirm,
    }
  },
}
</script>

<style lang="scss" scoped>
.sucai-search-bar {
  display: flex;
  align-items: center;
  gap: 12px;
  flex-wrap: wrap;
  margin-bottom: 16px;
}

.sucai-label {
  flex-shrink: 0;
  font-size: 14px;
  color: #606266;
}

.sucai-range-sep {
  color: #909399;
  margin: 0 -6px;
}

.sucai-duration-input {
  width: 76px;

  :deep(.el-input__inner) {
    height: 28px;
    line-height: 28px;
    padding: 0 6px;
    font-size: 12px;
    text-align: center;
  }
}

.sucai-grid {
  display: grid;
  grid-template-columns: repeat(auto-fill, minmax(150px, 1fr));
  gap: 12px;
  max-height: 420px;
  overflow-y: auto;
}

.sucai-grid-item {
  border: 1px solid #ebeef5;
  border-radius: 6px;
  overflow: hidden;
  background: #fff;
  cursor: pointer;
  transition: border-color 0.2s;

  &.active {
    border-color: #409eff;
    box-shadow: 0 0 0 1px #409eff;
  }
}

.sucai-cover {
  position: relative;
  height: 120px;
  background: #f5f7fa;

  img {
    width: 100%;
    height: 100%;
    object-fit: cover;
    display: block;
  }

  .sucai-mask {
    position: absolute;
    inset: 0;
    background: rgba(64, 158, 255, 0.25);
    border: 2px solid #409eff;
    box-sizing: border-box;
  }

  .sucai-check {
    position: absolute;
    top: 6px;
    right: 6px;
    width: 22px;
    height: 22px;
    line-height: 22px;
    text-align: center;
    background: #409eff;
    color: #fff;
    border-radius: 50%;
    font-size: 13px;
    font-weight: 700;
    box-shadow: 0 2px 6px rgba(0, 0, 0, 0.25);
    z-index: 1;
  }
}

.sucai-selected-count {
  font-size: 13px;
  color: #409eff;
}

.sucai-meta {
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  gap: 4px;
  padding: 6px 8px;
  min-width: 0;
}

.sucai-name {
  width: 100%;
  min-width: 0;
  font-size: 12px;
  color: #303133;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}

.sucai-duration {
  flex-shrink: 0;
  padding: 0 6px;
  font-size: 11px;
  line-height: 18px;
  color: #409eff;
  background: #ecf5ff;
  border-radius: 4px;
  white-space: nowrap;
}

.sucai-create-time {
  width: 100%;
  font-size: 11px;
  line-height: 16px;
  color: #909399;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}

.sucai-pagination {
  margin-top: 16px;
  display: flex;
  justify-content: flex-end;
}

.sucai-footer {
  margin-top: 16px;
  display: flex;
  justify-content: flex-end;
  gap: 12px;
}
</style>
